import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import AutoComplete from '@mui/material/Autocomplete';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import moment from 'moment';

function ThirdPartyLogisticsOrdersForm(props) {

    const [cleared, setCleared] = useState(false);

    useEffect(() => {
        if (cleared) {
        const timeout = setTimeout(() => {
            setCleared(false);
        }, 1500);

        return () => clearTimeout(timeout);
        }
        return () => {};
    }, [cleared]);

     return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} display = "flex" flexDirection = "column">
            <Stack direction = "row" alignItems = {"center"}>
                <FormControl sx = {{ mr: '10px', width: '20%' }}>
                    <LocalizationProvider dateAdapter = {AdapterMoment}>
                        <DesktopDatePicker
                            label = " Start Date *"
                            name = 'startDate'
                            onChange = {(event) => props.handleDateChange(event, 'startDate')}
                            value = {props.startDate ? moment(props.startDate) : moment()}
                            renderInput = {(params) => <TextField {...params} />}
                            slotProps = {{
                                field: { clearable: true, onClear: () => setCleared(true) },
                              }}
                        />
                    </LocalizationProvider>
                </FormControl>
                <FormControl sx = {{ mr: '10px', width: '20%' }}>
                    <LocalizationProvider dateAdapter = {AdapterMoment}>
                        <DesktopDatePicker
                            label = "End Date *"
                            name = 'endDate'
                            onChange = {(event) => props.handleDateChange(event, 'endDate')}
                            value = {props.endDate ? moment(props.endDate) : moment()}
                            renderInput = {(params) => <TextField {...params} />}
                            slotProps = {{
                                field: { clearable: true, onClear: () => setCleared(true) },
                              }}
                        />
                    </LocalizationProvider>
                </FormControl>
            </Stack>
            <Stack direction = "row" alignItems = {"center"} sx = {{mt: '20px'}}>
                <FormControl sx = {{ width: '20%', mr: '0.6%' }}>
                    <AutoComplete
                        value = {props.warehouse_options.find(option => option.value === props.warehouse) || null}
                        onChange = {(event, newValue) => {
                            props.setWarehouse(newValue ? newValue.value : null);
                        }}
                        id = "warehouse"
                        options = {props.warehouse_options}
                        getOptionLabel = {(option) => {
                            return `${option.name}`;
                        }}
                        renderOption = {(props, option) => {
                            return (
                                <li {...props}>
                                    {`${option.name}`}
                                </li>
                            );
                        }}
                        renderInput = {(params) => (
                            <TextField {...params} label = "Warehouse" />
                        )}
                    />
                </FormControl>
                {   props.warehouse ?
                        <FormControl sx = {{ width: '20%', mr: '0.6%' }}>
                            <AutoComplete
                                value = {props.customer_options.find(option => option.value === props.customer) || null}
                                onChange = {(event, newValue) => {
                                    props.setCustomer(newValue ? newValue.value : null);
                                }}
                                id = "customer"
                                options = {props.customer_options}
                                getOptionLabel = {(option) => {
                                    return `${option.name}`;
                                }}
                                renderOption = {(props, option) => {
                                    return (
                                        <li {...props}>
                                            {`${option.name}`}
                                        </li>
                                    );
                                }}
                                renderInput = {(params) => (
                                    <TextField {...params} label = "Customer" />
                                )}
                            />
                        </FormControl>
                    : null
                }
            </Stack>   
            {   props.customer ?
                    <Stack direction = "row" alignItems = {"center"} sx = {{mt: '20px'}}>
                        <Button sx = {{ml: '10px'}} onClick = {() => props.get3PLOrders()} disabled = {props.isLoading} variant = "contained" color = "success" >Get Orders From Acumatica</Button> 
                    </Stack>
                : null
            }
      </Box>
    );
  };

export default ThirdPartyLogisticsOrdersForm;